var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgInfoTerkini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10v8.5c0 1.4-1.1 2.5-2.5 2.5S18 19.9 18 18.5V8h3c1.1 0 2 .9 2 2zm-2.5 12H4c-2.2 0-4-1.8-4-4V4c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2v14.5c0 1.9 1.6 3.5 3.5 3.5zM13 13c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-1zm0-6c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h7c.6 0 1-.4 1-1V7z"
  })));
}

export default SvgInfoTerkini;